import {StringUtility} from "../../../common/StringUtility";

/// <summary>
/// PostStr表达式拼接
/// </summary>
export class PostStrExpressionSplice {

	constructor() {
		this.centerPointX = -1;
		this.centerPointY = -1;
		this.count = -1;
		this.keyWord = null;
		this.level = -1;
		this.maxLat = -1;
		this.maxLon = -1;
		this.minLat = -1;
		this.minLon = -1;
		this.queryTerminal = null;
		this.queryType = -1;
		this.radiusDistance = -1;
		this.specifyAdminCode = null;
		this.start = -1;
	}



	/**
		 *获得拼接的表达式 
		 * @return 
		 */
	GetExpression() {
		let express = null;

		express = "{";

		//赋具体的参数
		let levelString = this.GetAttriExpress("level", this.level, -1);
		let keyWordString = this.GetAttriExpress("keyWord", this.keyWord, null);
		let queryTypeString = this.GetAttriExpress("queryType", this.queryType, -1);
		let mapBoundString = this.GetMapBoundsExpress(this.minLon, this.minLat, this.maxLon, this.maxLat);
		let centerPnt = this.GetCenterPointExpress(this.centerPointX, this.centerPointY);
		let countString = this.GetAttriExpress("count", this.count, -1);
		let startString = this.GetAttriExpress("start", this.start, -1);
		let radiusString = this.GetAttriExpress("queryRadius", this.radiusDistance, -1);
		let specifyAdminCodeString = this.GetAttriExpress("specifyAdminCode", this.specifyAdminCode, null);
		let queryTerminalString = this.GetAttriExpress("queryTerminal", this.queryTerminal, null);

		if (levelString != null) {
			express = express + levelString + ",";
		}

		if (keyWordString != null) {
			express = express + keyWordString + ",";
		}

		if (queryTypeString != null) {
			express = express + queryTypeString + ",";
		}

		if (mapBoundString != null) {
			express = express + mapBoundString + ",";
		}

		if (centerPnt != null) {
			express = express + centerPnt + ",";
		}

		if (countString != null) {
			express = express + countString + ",";
		}

		if (startString != null) {
			express = express + startString + ",";
		}

		if (radiusString != null) {
			express = express + radiusString + ",";
		}

		if (specifyAdminCodeString != null) {
			express = express + specifyAdminCodeString + ",";
		}

		if (queryTerminalString != null) {
			express = express + queryTerminalString + ",";
		}


		if (StringUtility.endsWith(express, ",")) {
			express = express.substr(0, express.length - 1);
		}

		express = express + "}";

		return express;
	}

	/**
	 *获得属性字段的表达式 
	 * @param attriName
	 * @param attriValue
	 * @param defaultValue
	 * @return 
	 * 
	 */
	GetAttriExpress(attriName, attriValue, defaultValue) {
		let attriExp = null;
		

		if (attriName == null || StringUtility.trim(attriName) == ""
			|| attriValue == defaultValue) return attriExp;

			

		attriExp = "\"" + attriName + "\":\"" + attriValue + "\"";

		return attriExp;
	}

	GetMapBoundsExpress(minX, minY, maxX, maxY) {
		let mapExpress = null;
		

		if (minX == -1 || minY == -1 || maxX == -1 || maxY == -1) return mapExpress;
		mapExpress = "\"mapBound\":\"" + minX + "," + minY + "," + maxX + "," + maxY + "\"";

		return mapExpress;
	}

	/**
	 *获得中心点表达式 
	 * @param centerX
	 * @param centerY
	 * @return 
	 * 
	 */
	GetCenterPointExpress(centerX, centerY) {
		let centerPntExp = null;
		if (centerX == -1 || centerY == -1) return centerPntExp;
		centerPntExp = "\"pointLonlat\":\"" + centerX + "," + centerY + "\"";
		return centerPntExp;
	}


}


